// PublicRoute.tsx
import { Navigate } from "react-router-dom";
import { isTokenExpired } from "../utils/Auth/auth";

const PublicRoute = ({ children }: any) => {
  const token = localStorage.getItem("token");

  if (token && !isTokenExpired(token)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;